import React from "react";

const BubbleLoader = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <div
        class="spinner-grow spinner-grow-sm"
        role="status"
        style={{ marginRight: "20px" }}
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      <div
        class="spinner-grow spinner-grow-sm"
        role="status"
        style={{ marginRight: "20px" }}
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow spinner-grow-sm" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default BubbleLoader;
